export function initAccordion($accordion) {

  /**
   * Accordion jQuery — snippet base
   *
   * Opzioni via data attributes sull'elemento .accordion:
   *   data-transition="true"   → abilita animazione max-height
   *   data-duration="380"      → durata in ms (default: 380)
   */

  const $trigger    = $accordion.find('.accordion__trigger');
  const $body       = $accordion.find('.accordion__body');
  const useTransition = $accordion.data('transition') === true;
  const duration      = $accordion.data('duration') || 100;
  const isOpenClass = 'open'

  // Applica la transition CSS solo se richiesta
  if (useTransition) {
    $body.css('transition', 'max-height ' + duration + 'ms cubic-bezier(0.4,0,0.2,1)');
  }

  $trigger.on('click', function () {
    const isOpen = $accordion.hasClass(isOpenClass);

    if (isOpen) {
      // CHIUDI
      $accordion.removeClass(isOpenClass);
      if (useTransition) {
        // Prima forza il valore corrente, poi porta a 0
        $body.css('max-height', $body[0].scrollHeight + 'px');
        requestAnimationFrame(function () {
          $body.css('max-height', '0');
        });
      } else {
        $body.css('max-height', '0');
      }
    } else {
      // APRI
      $accordion.addClass(isOpenClass);
      $body.css('max-height', $body[0].scrollHeight + 'px');
      if (!useTransition) {
        // senza transizione non serve resettare a "none"
      } else {
        // dopo l'animazione, metti "none" così il contenuto
        // può crescere liberamente (es. contenuto dinamico)
        $body.one('transitionend', function () {
          if ($accordion.hasClass(isOpenClass)) {
            $body.css('max-height', 'none');
          }
        });
      }
    }
  });

}
